import dayjs from 'dayjs';

export const completeDate = 'YYYY-MM-DD';
export const viewDate = 'DD MMM';
export const monthYearDate = 'YYYY-MM';
/** Calendar heading above each month of the range picker, e.g. September 2026 */
export const pickerTitleDate = 'MMMM YYYY';

export const getNights = (dateStart, dateEnd) => {
  return Math.abs(dayjs(dateEnd).diff(dayjs(dateStart), 'days'));
};

export const getRangeDatesFormatted = (dateStart, dateEnd) => {
  const start = dayjs(dateStart).format(viewDate);
  const end = dayjs(dateEnd).format(viewDate);
  return `${start} - ${end}`;
};
